module.exports = __webpack_public_path__ + "img/gzs.9aedd89c.svg";